import React from 'react';
import PropTypes from 'prop-types';
import ErrorMessage from './ErrorMessage';
import useFormControl from './useFormControl';
import './style.scss';

const FormRadioGroup = ({
  field,
  validation,
  className,
  disabled = false,
  readOnly = false,
  list,
  custom = false,
  wrapLabels = false,
  style,
  onChange,
  id,
  'aria-label': ariaLabel,
  'aria-describedby': ariaDescribedBy,
}) => {
  const {
    describedBy,
    error,
    errorId,
    errorMessage,
    fieldValue,
    hasError,
    inputId,
    isFlashing,
    setFieldValue,
  } = useFormControl({ field, validation, id, ariaDescribedBy });

  return (
    <React.Fragment>
      <div
        id={inputId}
        data-field={field}
        role='radiogroup'
        aria-label={ariaLabel}
        aria-invalid={hasError || undefined}
        aria-describedby={describedBy}
        aria-disabled={disabled || readOnly || undefined}
        className={[
          'bw_form_choice_group',
          !custom ? 'bw_lb_sex bw_sex_group' : 'bw_lb_sex',
          className,
          hasError ? 'is-invalid' : '',
          isFlashing ? 'bw_field_error_flash' : '',
        ]
          .filter(Boolean)
          .join(' ')}>
        {(list || []).map((item, index) => {
          const optionId = item.id || item.key || `${inputId}-${index}`;
          return (
            <React.Fragment key={item.key ?? item.value ?? index}>
              <label className={`bw_radio bw_form_choice_option ${disabled || readOnly ? 'is-disabled' : ''}`} style={style}>
                <input
                  type='radio'
                  name={field}
                  id={optionId}
                  disabled={disabled || readOnly}
                  checked={String(fieldValue) === String(item.value)}
                  onChange={() => {
                    setFieldValue(item.value);
                    if (typeof onChange === 'function') onChange(item.value);
                  }}
                />
                <span />
                {item.img ? (
                  <img
                    style={{
                      width: '50px',
                      height: '50px',
                      objectFit: 'contain',
                      padding: '4px',
                      borderRadius: '10px',
                      marginRight: '3px',
                      border: '1px solid rgba(0,0,0,0.08)',
                    }}
                    src={item.img}
                    onError={(event) => {
                      if (!item.imgFallback || event.currentTarget.dataset.fallbackApplied === 'true') return;
                      event.currentTarget.dataset.fallbackApplied = 'true';
                      event.currentTarget.src = item.imgFallback;
                    }}
                    alt='logo'
                  />
                ) : null}
                {wrapLabels ? <b className='bw_form_choice_text'>{item.label}</b> : item.label}
              </label>
            </React.Fragment>
          );
        })}
      </div>
      {error && <ErrorMessage id={errorId} message={errorMessage} />}
    </React.Fragment>
  );
};
FormRadioGroup.propTypes = {
  field: PropTypes.string,
  validation: PropTypes.object,
  content: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  checked: PropTypes.bool,
  className: PropTypes.string,
  id: PropTypes.string,
  'aria-label': PropTypes.string,
  list: PropTypes.arrayOf(PropTypes.object),
  onChange: PropTypes.func,
};

export default FormRadioGroup;
